import { IconCircleDot } from '@tabler/icons-react';

type Props = {
  color: 'green' | 'red';
};

export function StatusIcon({ color }: Props) {
  if (color === 'green') {
    return (
      <IconCircleDot
        style={{ width: '1.2em', height: '1.2em' }}
        stroke={1.5}
        className="text-plamo-success mr-1"
      />
    );
  }
  if (color === 'red') {
    return (
      <IconCircleDot
        style={{ width: '1.2em', height: '1.2em' }}
        stroke={1.5}
        className="text-plamo-error mr-1"
      />
    );
  }
  return '';
}
